import { Chip, chipClasses, ChipProps, styled, Theme } from '@mui/material';
import { useNavigateRoute } from 'src/utils/routing';

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'iconColor' && prop !== 'path',
})<ActivityRefChipProps>(({ theme, iconColor }) => ({
  borderWidth: 0,
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.custom.OV.sys.surface,

  [`.${chipClasses.icon}`]: {
    fontSize: theme.spacing(2),
    width: 'auto',
    height: 'auto',
    marginLeft: theme.spacing(0.5),
    color: iconColor?.(theme),
  },
}));

export type ActivityRefChipProps = ChipProps & {
  iconColor?: (theme: Theme) => string;
  path: string;
};

export const ActivityRefChip = (props: ActivityRefChipProps) => {
  const { navigate } = useNavigateRoute();
  return (
    <StyledChip
      variant="outlined"
      size="small"
      {...props}
      onClick={() => {
        navigate(props.path);
      }}
    />
  );
};
